// src/api/customer.js
import { customerApi } from "../utils/apiConfig";

export const loginCustomer = (email, password) =>
  customerApi.post("/login", { email, password });

export const verifyOtpMethod = (otpToken, otp) =>
  customerApi.post("/verifyOtpMethod", { otpToken, otp });

export const resendOtpMethod = (otpToken) =>
  customerApi.post("/resendOtpMethod", { otpToken });

export const registerCustomer = (customerData) =>
  customerApi.post("/register", customerData);

export const updateProfile = (customerData) =>
  customerApi.post("/updateProfile", customerData, { headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` } });

export const getProfile = (userId) =>
  customerApi.post("/getProfile", { userId }, { headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` } });

export const getAuthMe = () => {
  return customerApi.get("/authMe", {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const getPersonel = () => {
  return customerApi.get("/getPersonel", {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

